/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_IndustrySectorDto } from '../models/PagedResultDto_IndustrySectorDto';
import type { Wealthlane_CustomerService_Dtos_IndustrySector_CreateUpdateIndustrySectorDto } from '../models/Wealthlane_CustomerService_Dtos_IndustrySector_CreateUpdateIndustrySectorDto';
import type { Wealthlane_CustomerService_Dtos_IndustrySector_IndustrySectorDto } from '../models/Wealthlane_CustomerService_Dtos_IndustrySector_IndustrySectorDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IndustrySectorService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_IndustrySector_IndustrySectorDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppIndustrySectorIndustrySectors(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_IndustrySector_IndustrySectorDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/industry-sector/industry-sectors',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_IndustrySector_IndustrySectorDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppIndustrySector(
requestBody?: Wealthlane_CustomerService_Dtos_IndustrySector_CreateUpdateIndustrySectorDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_IndustrySector_IndustrySectorDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/industry-sector',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_IndustrySectorDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppIndustrySector(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_IndustrySectorDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/industry-sector',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_IndustrySector_IndustrySectorDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppIndustrySector(
id: string,
requestBody?: Wealthlane_CustomerService_Dtos_IndustrySector_CreateUpdateIndustrySectorDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_IndustrySector_IndustrySectorDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/industry-sector/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppIndustrySector(
id: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/industry-sector/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_IndustrySector_IndustrySectorDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppIndustrySector1(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_IndustrySector_IndustrySectorDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/industry-sector/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
